const ACTIVE_VISION_PHASES = new Set([
  "requesting",
  "starting",
  "recording",
  "paused",
  "finalizing",
]);

export const visionRecorderOwnsMedia = (state) => {
  const snapshot = state !== undefined
    ? state
    : (typeof window !== "undefined" ? window.__leviVisionState : null);
  if (!snapshot || snapshot.active !== true) return false;
  return ACTIVE_VISION_PHASES.has(String(snapshot.status || "").toLowerCase());
};

export const publishVisionRecorderPhase = (status, detail = {}) => {
  if (typeof window === "undefined") return;
  const prior = window.__leviVisionState || {};
  window.__leviVisionState = {
    ...prior,
    ...detail,
    status,
    active: ACTIVE_VISION_PHASES.has(String(status || "").toLowerCase()),
    updated_at: new Date().toISOString(),
  };
};

export const startMediaRecorderSafely = (recorder, timeslice, onDiagnostic) => {
  try {
    recorder.start(timeslice);
    return { ok: true, errorName: null, errorMessage: null };
  } catch (error) {
    const outcome = {
      ok: false,
      errorName: error?.name || "MediaRecorderStartError",
      errorMessage: error?.message || "MediaRecorder.start failed",
    };
    try { onDiagnostic?.(outcome); } catch { /* noop */ }
    return outcome;
  }
};
